import { Dimensions } from '../../../types/ad';
import { LimitedCloudVisionResponse } from '../../../types/cloudVision';
import { analyze, annotateImage, clearAnnotation } from '../cropping';
import { postMessageToParent } from '../helpers/collapse-iframe-message';

export default {
    callable: (element: HTMLElement) => {
        const srcSetElements = element.querySelectorAll(
            'img[data-distribution-srcset]'
        );
        const { debug } = document.body.dataset;

        [].forEach.call(srcSetElements, (img: HTMLImageElement) => {
            img.onload = () => {
                if (img.parentNode) {
                    const src = img.currentSrc ? img.currentSrc : img.src;
                    const parent = img.parentNode as HTMLElement;
                    parent.style.backgroundImage = `url("${src}")`;

                    const aspectRatio = img.width / img.height;

                    const squareTime =
                        (parent.clientHeight - parent.clientWidth) / 60;

                    const time = squareTime * aspectRatio * 2;

                    parent.style.animationDuration = `${time}s`;

                    if (debug) {
                        console.log(
                            'onLoad',
                            {
                                clientHeight: parent.clientHeight,
                                clientWidth: parent.clientWidth,
                            },
                            src
                        );
                    }

                    const config = readConfig(parent);
                    if (config) {
                        const { cropConfig, dimensions, annotate } = config;
                        window.addEventListener('resize', () => {
                            document
                                .querySelectorAll('img[srcset]')
                                .forEach(function (img) {
                                    (img as HTMLImageElement).src += '';
                                });

                            if (debug) {
                                console.log('resize', {
                                    clientHeight: parent.clientHeight,
                                    clientWidth: parent.clientWidth,
                                });
                            }

                            updateBackgroundPosition(
                                cropConfig,
                                dimensions,
                                img,
                                annotate
                            );
                        });

                        updateBackgroundPosition(
                            cropConfig,
                            dimensions,
                            img,
                            annotate
                        );
                    } else {
                        window.addEventListener('resize', () => {
                            document
                                .querySelectorAll('img[srcset]')
                                .forEach(function (img) {
                                    (img as HTMLImageElement).src += '';
                                });

                            if (debug) {
                                console.log('resize', {
                                    clientHeight: parent.clientHeight,
                                    clientWidth: parent.clientWidth,
                                });
                            }
                        });
                    }
                    postMessageToParent({ mainImageLoaded: true });
                }
            };
        });
    },
};

function updateBackgroundPosition(
    config: LimitedCloudVisionResponse,
    dimensions: Dimensions,
    img: HTMLImageElement,
    annotateServer?: boolean
) {
    const urlParams = new URLSearchParams(window.location.search);
    const annotate = annotateServer || urlParams.has('annotate');

    const parent = img.parentNode as HTMLElement;

    const availableHeight = parent.clientHeight;
    const availableWidth = parent.clientWidth;

    const analyzedWidth = dimensions.width;
    const analyzedHeight = dimensions.height;

    if (analyzedWidth) {
        const widthScale = availableWidth / analyzedWidth;
        const heightScale = availableHeight / analyzedHeight;

        if (widthScale < heightScale) {
            parent.style.backgroundPositionX = 'center';
            if (config.imageType === 'BRAND_PICTURE') {
                parent.style.backgroundPositionY = 'center';
                parent.style.backgroundSize = 'contain';
            } else {
                parent.style.backgroundPositionY = 'top';
            }
            clearAnnotation(img);
        } else {
            const { top, bottom, debug } = analyze(
                config,
                availableHeight * (1 / widthScale),
                availableWidth * (1 / widthScale),
                analyzedHeight,
                analyzedWidth,
                annotate
            );

            parent.style.backgroundPositionX = 'center';
            parent.style.backgroundPositionY = `-${top * widthScale}px`;
            parent.style.backgroundSize = 'cover';

            if (annotate) {
                annotateImage(
                    img,
                    { top: top, bottom: bottom },
                    analyzedWidth,
                    widthScale,
                    debug
                );
            }
        }
    }
}

type Config = {
    cropConfig: LimitedCloudVisionResponse;
    dimensions: Dimensions;
    annotate?: boolean;
};

const readConfig = (parent: HTMLElement): Config | undefined => {
    if (parent) {
        const configs = parent.getElementsByTagName('script');
        if (configs.length) {
            const exampleConfig = configs[0];
            if (exampleConfig && exampleConfig.innerHTML) {
                return JSON.parse(exampleConfig.innerHTML);
            }
        }
    }
    return;
};
